import _ from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import { Item } from '@/interfaces/item'
import CardTitle from '@/components/CardTitle.vue'
import DeleteAction from '@/components/DeleteAction.vue'
import { FiltersMixin } from '@/mixins/filters.mixin'
import { mixins } from 'vue-class-component'

@Component({
  components: {
    DeleteAction,
    CardTitle
  }
})
export class ListMixin<I extends Item = Item> extends mixins(FiltersMixin) implements FiltersMixin {
  items: I[] = []
  loading: boolean = false
  creating: boolean = false
  editing: I | null = null
  apiConfig!: FetchConfig
  fetchTimeout: number | null = null
  lastFetchParams?: any

  setEditing(item: I) {
    this.editing = item
  }

  async beforeFetch() {}

  async afterFetch(result) {
    return result
  }

  get fetchParams() {
    const fixed = this.apiConfig!.params
    const mixed = _.merge({}, fixed, { filter: this.filterQuery })

    if (this.pagination) {
      _.merge(mixed, { limit: this.pagination.pageSize, page: this.pagination.current || 1 })
    }

    return mixed
  }

  pagination: any = {
    pageSize: 12
  }

  handleTableChange(pagination, filters, sorter) {
    if (this.pagination === null) return

    this.pagination = {
      ...this.pagination,
      ...pagination
    }

    return this.delayedFetch(200, false)
  }

  async fetch(checkQuery = false): Promise<void> {
    if (this.loading) return
    if (checkQuery && _.isEqual(this.fetchParams, this.lastFetchParams)) return

    this.lastFetchParams = _.cloneDeep(this.fetchParams)
    this.loading = true
    await this.beforeFetch()

    try {
      let result = await this.$api.get(this.apiConfig!.path, { params: this.fetchParams })
      result = await this.afterFetch(result)

      const { data } = result
      if (this.pagination || data.page) {
        this.items = data.page ? data.data : data
        this.pagination = {
          ...this.pagination,
          current: data.page || 1,
          total: data.total || 0
        }
      } else {
        this.items = data
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.loading = false
    }
  }

  async delayedFetch(delay = 500, checkQuery = true) {
    if (this.fetchTimeout) clearTimeout(this.fetchTimeout)
    setTimeout(() => {
      this.fetch(checkQuery)
    }, delay)
  }

  async created() {
    await this.$nextTick()
    this.fetch()
  }

  @Watch('filterValues', { deep: true })
  onFilterChange() {
    return this.delayedFetch()
  }

  customRow(record) {
    return {
      on: {
        dblclick: () => {
          this.setEditing(record)
        }
      }
    }
  }
}

interface FetchConfig {
  path: string
  params?: any
}
